import { render, staticRenderFns } from "./PersonnelRecordEditTabYouthGroup.vue?vue&type=template&id=1507b1df"
import script from "./PersonnelRecordEditTabYouthGroup.vue?vue&type=script&lang=js"
export * from "./PersonnelRecordEditTabYouthGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports